module.exports = __webpack_public_path__ + "staticVue/img/join_us04.e9393abc.jpg";